
import { Components } from "appworks/components/components";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { Contract } from "appworks/utils/contracts/contract";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export function StopSpinCommand(spinRecord: SpinRecord) {
    const settings = Model.read().settings;
    const quickSpin = settings.quickSpin || settings.turboSpin;

    return new Contract<void>((resolve) => {
        Components.get(AbstractMatrixComponent).stopTransition(spinRecord, quickSpin).then(() => {
            if (spinRecord && spinRecord instanceof FreespinRecord) {
                Services.sound.event(SoundEvent.end_freespin);
            } else {
                Services.sound.event(SoundEvent.end_spin);
            }
            resolve(null);
        });
    });
}
